module.exports = __webpack_public_path__ + "media/icons/i-5-questions-0a3bf53b.png";